import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreateDomicilio = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/domicilios`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearDomicilioMutation: mutation.mutate,
    };
}